import usePageName from "../../../hocs/usePageName";
import { Container } from "@mui/material";
import PickupReviewAndSign from "../../admin/ReadyForPickup/PickupReviewAndSign";

const CustomerReviewAndSignPickupPage = () => {
  usePageName({
    heading: "Review & Sign Pickup",
    caption: null,
  });
  return (
    <Container>
      <PickupReviewAndSign />
    </Container>
  );
};

export default CustomerReviewAndSignPickupPage;
